module.exports = __webpack_public_path__ + "img/109.94206cd2.jpg";